<template>
	<Modal
		modal-name="MzLoginModal"
		type="dialog"
		class="mz-login-modal"
		:theme="$arenaConfig.isLightTheme ? null : 'dark'"
		data-testid="mz-login-modal"
	>
		<template #title>
			{{ $I18n.trans('arena.login.button') }}
		</template>
		<template #content>
			<div class="mz-login-modal__tiles">
				<a
					class="mz-login-modal__tile"
					:href="getLoginUrl(PROVIDER_VS)"
					data-testid="mz-login-volksstimme"
				>
					<span class="mz-login-modal__tile-label">
						Volksstimme
					</span>
					<img
						class="mz-login-modal__tile-icon"
						:src="volksstimmeLogo"
						alt="Volksstimme"
					>
				</a>
				<a
					class="mz-login-modal__tile"
					:href="getLoginUrl(PROVIDER_MZ)"
					data-testid="mz-login-mz"
				>
					<span class="mz-login-modal__tile-label">
						Mitteldeutsche Zeitung
					</span>
					<img
						class="mz-login-modal__tile-icon"
						:src="mzLogo"
						alt="Mitteldeutsche Zeitung"
					>
				</a>
			</div>
		</template>
	</Modal>
</template>

<script>
import Modal from '@shared/components/Modal';
import laroute from '@laroute';
import volksstimmeLogo from '@legacy/images/logo-vs.svg';
import mzLogo from '@legacy/images/logo-mz.svg';

const PROVIDER_VS = 'vs';
const PROVIDER_MZ = 'mz';

export default {
	name:       'MzLoginModal',
	components: { Modal },
	data() {
		return {
			volksstimmeLogo,
			mzLogo,
			PROVIDER_VS,
			PROVIDER_MZ,
		};
	},
	methods: {
		// Keep SSO on the arena login route so redirectUrl and provider reach the backend.
		getLoginUrl(provider) {
			const loginRoute = laroute.route('arena.login');
			const query = new URLSearchParams({
				redirectUrl: window.location.href,
				provider,
			});

			return `${loginRoute}?${query.toString()}`;
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@sass/variables';

.mz-login-modal__tiles {
	display: flex;
	gap: $sp4;

	@include size(sm-down) {
		flex-direction: column;
	}
}

.mz-login-modal__tile {
	display: flex;
	flex: 1 1 0;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: $sp3;
	min-height: 120px;
	padding: $sp5;
	background-color: var(--color-grey-950);
	border-radius: $border-radius--lg;
	text-decoration: none;

	@include size(sm-down) {
		min-height: 96px;
	}
}

.mz-login-modal__tile-label {
	@include font(primary, medium, normal, fs-100);
	margin-bottom: $sp5;

	color: var(--color-white);
	text-align: center;
}

.mz-login-modal__tile-icon {
	display: block;
	max-width: 100%;
	max-height: 64px;
	object-fit: contain;
}
</style>
